import { z } from 'zod';

export const FeatureFlagsSchema = z.object({
  enableThemeToggle: z
    .boolean({
      error: (issue) =>
        issue.input === undefined
          ? 'Provide the variable NEXT_PUBLIC_ENABLE_THEME_TOGGLE'
          : undefined,
    })
    .describe('Enable theme toggle in the user interface.'),
  enableAccountDeletion: z
    .boolean({
      error: (issue) =>
        issue.input === undefined
          ? 'Provide the variable NEXT_PUBLIC_ENABLE_PERSONAL_ACCOUNT_DELETION'
          : undefined,
    })
    .describe('Enable personal account deletion.'),
  enableTeamDeletion: z
    .boolean({
      error: (issue) =>
        issue.input === undefined
          ? 'Provide the variable NEXT_PUBLIC_ENABLE_TEAM_ACCOUNTS_DELETION'
          : undefined,
    })
    .describe('Enable team deletion.'),
  enableTeamAccounts: z
    .boolean({
      error: (issue) =>
        issue.input === undefined
          ? 'Provide the variable NEXT_PUBLIC_ENABLE_TEAM_ACCOUNTS'
          : undefined,
    })
    .describe('Enable team accounts.'),
  enableTeamCreation: z
    .boolean({
      error: (issue) =>
        issue.input === undefined
          ? 'Provide the variable NEXT_PUBLIC_ENABLE_TEAM_ACCOUNTS_CREATION'
          : undefined,
    })
    .describe('Enable team creation.'),
  enablePersonalAccountBilling: z
    .boolean({
      error: (issue) =>
        issue.input === undefined
          ? 'Provide the variable NEXT_PUBLIC_ENABLE_PERSONAL_ACCOUNT_BILLING'
          : undefined,
    })
    .describe('Enable personal account billing.'),
  enableTeamAccountBilling: z
    .boolean({
      error: (issue) =>
        issue.input === undefined
          ? 'Provide the variable NEXT_PUBLIC_ENABLE_TEAM_ACCOUNTS_BILLING'
          : undefined,
    })
    .describe('Enable team account billing.'),
  languagePriority: z
    .enum(['user', 'application'], {
      error: (issue) =>
        issue.input === undefined
          ? 'Provide the variable NEXT_PUBLIC_LANGUAGE_PRIORITY'
          : undefined,
    })
    .describe(
      `If set to user, use the user's preferred language. If set to application, use the application's default language.`,
    )
    .default('application'),
  enableNotifications: z
    .boolean({
      error: (issue) =>
        issue.input === undefined
          ? 'Provide the variable NEXT_PUBLIC_ENABLE_NOTIFICATIONS'
          : undefined,
    })
    .describe('Enable notifications functionality'),
  realtimeNotifications: z
    .boolean({
      error: (issue) =>
        issue.input === undefined
          ? 'Provide the variable NEXT_PUBLIC_REALTIME_NOTIFICATIONS'
          : undefined,
    })
    .describe('Enable realtime for the notifications functionality'),
  enableVersionUpdater: z
    .boolean({
      error: (issue) =>
        issue.input === undefined
          ? 'Provide the variable NEXT_PUBLIC_ENABLE_VERSION_UPDATER'
          : undefined,
    })
    .describe('Enable version updater'),
  enableSavedSignatures: z
    .boolean({
      error: (issue) =>
        issue.input === undefined
          ? 'Provide the variable NEXT_PUBLIC_ENABLE_SAVED_SIGNATURES'
          : undefined,
    })
    .describe('Enable saved signatures functionality'),
  enableCoaching: z
    .boolean({
      error: (issue) =>
        issue.input === undefined
          ? 'Provide the variable NEXT_PUBLIC_ENABLE_COACHING'
          : undefined,
    })
    .describe('Enable coaching pages and navigation'),
  enableAmbassadors: z
    .boolean({
      error: (issue) =>
        issue.input === undefined
          ? 'Provide the variable NEXT_PUBLIC_ENABLE_AMBASSADORS'
          : undefined,
    })
    .describe('Enable the brand-ambassadors module (pages + navigation)'),
  enableAgencyContractSigning: z
    .boolean()
    .describe('Ask cast dancers to sign the Ballee agency contract'),
  enableMarketplaceCommerce: z
    .boolean({
      error: (issue) =>
        issue.input === undefined
          ? 'Provide the variable NEXT_PUBLIC_ENABLE_MARKETPLACE_COMMERCE'
          : undefined,
    })
    .describe(
      'Enable Stripe Connect payments + commission on the marketplace. When false, the marketplace runs in free / contact-seller mode (buyers DM the seller via /home/inbox).',
    ),
});
